<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th.text-center(width="3%")
          span #
        th(width="10%")
          span(:title="$t('ui.working_date')") {{ $t('ui.working_date') }}
        th.text-right(width="11%")
          span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
        th.text-right(width="11%")
          span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
        th.text-right(width="11%")
          span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
        th.text-right(width="11%")
          span(:title="$t('ui.deposit_amount')") {{ $t('ui.deposit_amount') }}
        th.text-right(width="11%")
          span(:title="$t('ui.deposit_count')") {{ $t('ui.deposit_count') }}
        th.text-right(width="11%")
          span(:title="$t('ui.withdrawal_amount')") {{ $t("ui.withdrawal_amount") }}
        th.text-right(width="11%")
          span(:title="$t('ui.withdrawal_count')") {{ $t('ui.withdrawal_count') }}
        th.text-right(width="11%")
          span(:title="$t('ui.bonus_amount')") {{ $t("ui.bonus_amount") }}
        th.text-right(width="11%")
          span(:title="$t('ui.adjustment_amount')") {{ $t("ui.adjustment_amount") }}
        th.text-right(width="11%")
          span(:title="$t('ui.verified_count')") {{ $t("ui.verified_count") }}
        th.text-right(width="11%")
          span(:title="$t('ui.active_member')") {{ $t("ui.active_member") }}
        th.text-right(width="11%")
          span(:title="$t('ui.referee_count')") {{ $t("ui.referee_count") }}
        th.text-right(width="11%")
          span(:title="$t('ui.signup_count')") {{ $t("ui.signup_count") }}
        th.text-right(width="11%")
          span(:title="$t('ui.ftd_count')") {{ $t("ui.ftd_count") }}
        th.text-right(width="11%")
          span(:title="$t('ui.ftd_amount')") {{ $t("ui.ftd_amount") }}
        th.text-right(width="11%")
          span(:title="$t('ui.unique_login_count')") {{ $t("ui.unique_login_count") }}
        th.text-right(width="11%")
          span(:title="$t('ui.unique_withdrawal_count')") {{ $t("ui.unique_withdrawal_count") }}
        th.text-right(width="11%")
          span(:title="$t('ui.second_deposit_count')") {{ $t("ui.second_deposit_count") }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(colspan="20").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl")
        td.text-center
          span(:title="index + 1") {{ index + 1 }}
        td
          span(:title="$moment(item.working_date).format('YYYY-MM-DD')") {{ $moment(item.working_date).format('YYYY-MM-DD') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.deposit_amount)" :title="$n(item.deposit_amount, 'currency')") {{ $n(item.deposit_amount, 'currency') }}
        td.text-right
          span.font-weight-bold(:title="$n(item.deposit_count, 'integer')") {{ $n(item.deposit_count, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.withdrawal_amount * -1)" :title="$n(item.withdrawal_amount > 0 ? item.withdrawal_amount * -1 : item.withdrawal_amount, 'currency')") {{ $n(item.withdrawal_amount > 0 ? item.withdrawal_amount * -1 : item.withdrawal_amount, 'currency') }}
        td.text-right
          span.font-weight-bold(:title="$n(item.withdrawal_count, 'integer')") {{ $n(item.withdrawal_count, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.bonus_amount)" :title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="[item.adjustment_amount < 0 ? 'text-danger' : 'text-info']" :title="$n(item.adjustment_amount, 'currency')") {{ $n(item.adjustment_amount, 'currency') }}
        td.text-right
          span.font-weight-bold(v-if="item.verified_count == 0" :class="$helpers.fontClassName(item.verified_count)" :title="$n(item.verified_count, 'integer')") {{ $n(item.verified_count, 'integer') }}
          span.font-weight-bold(v-if="item.verified_count != 0")
            template
              span.font-weight-bold(href="javascript:void(0);" :class="$helpers.fontClassName(item.verified_count, true)" :title="$n(item.verified_count, 'integer')") {{ $n(item.verified_count, 'integer') }}
        td.text-right
          span.font-weight-bold(:title="item.active_member") {{ item.active_member }}
        td.text-right
          span.font-weight-bold(:title="item.referee_count") {{ item.referee_count }}
        td.text-right
          span.font-weight-bold(:title="item.signup_count") {{ item.signup_count }}
        td.text-right
          span.font-weight-bold(v-if="item.ftd_count == 0" :class="$helpers.fontClassName(item.ftd_count)" :title="$n(item.ftd_count, 'integer')") {{ $n(item.ftd_count, 'integer') }}
          span.font-weight-bold(v-if="item.ftd_count != 0")
            template
              span.font-weight-bold(href="javascript:void(0);" :class="$helpers.fontClassName(item.ftd_count, true)" :title="$n(item.ftd_count, 'integer')") {{ $n(item.ftd_count, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.ftd_amount)" :title="$n(item.ftd_amount, 'currency')") {{ $n(item.ftd_amount, 'currency') }}
        td.text-right
          template
            span.font-weight-bold.text-info(:title="item.unique_login_count") {{ item.unique_login_count }}
        td.text-right
          template
            span.font-weight-bold.text-info(:title="item.unique_withdrawal_count") {{ item.unique_withdrawal_count }}
        td.text-right
          template
            span.font-weight-bold.text-info(:title="item.second_deposit_count") {{ item.second_deposit_count }} 
      tr.footer
        td.text-right(colspan="2")
          span {{ $t("ui.sub_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnover)" :title="$n(subTotalTurnover, 'currency')") {{ $n(subTotalTurnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnover)" :title="$n(subTotalValidTurnover, 'currency')") {{ $n(subTotalValidTurnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLose)" :title="$n(subTotalWinLose, 'currency')") {{ $n(subTotalWinLose, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalDepositAmount)" :title="$n(subTotalDepositAmount, 'currency')") {{ $n(subTotalDepositAmount, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalDepositCount)" :title="$n(subTotalDepositCount, 'integer')") {{ $n(subTotalDepositCount, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="[subTotalWithdrawalAmount == 0 ? 'text-primary' : 'text-danger']" :title="$n(subTotalWithdrawalAmount > 0 ? subTotalWithdrawalAmount * -1 : subTotalWithdrawalAmount, 'currency')") {{ $n(subTotalWithdrawalAmount > 0 ? subTotalWithdrawalAmount * -1 : subTotalWithdrawalAmount, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalWithdrawalCount)" :title="$n(subTotalWithdrawalCount, 'integer')") {{ $n(subTotalWithdrawalCount, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalBonusAmount)" :title="$n(subTotalBonusAmount, 'currency')") {{ $n(subTotalBonusAmount, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalAdjustmentAmount)" :title="$n(subTotalAdjustmentAmount, 'currency')") {{ $n(subTotalAdjustmentAmount, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalVerifiedCount)" :title="$n(subTotalVerifiedCount, 'integer')") {{ $n(subTotalVerifiedCount, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalActiveMember)" :title="$n(subTotalActiveMember, 'integer')") {{ $n(subTotalActiveMember, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalRefereeCount)" :title="$n(subTotalRefereeCount, 'integer')") {{ $n(subTotalRefereeCount, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalSignupCount)" :title="$n(subTotalSignupCount, 'integer')") {{ $n(subTotalSignupCount, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalFtdCount)" :title="$n(subTotalFtdCount, 'integer')") {{ $n(subTotalFtdCount, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalFtdAmount)" :title="$n(subTotalFtdAmount, 'currency')") {{ $n(subTotalFtdAmount, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalUniqueLoginCount)" :title="$n(subTotalUniqueLoginCount, 'integer')") {{ $n(subTotalUniqueLoginCount, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalUniqueWithdrawalCount)" :title="$n(subTotalUniqueWithdrawalCount, 'integer')") {{ $n(subTotalUniqueWithdrawalCount, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalSecondDepositCount)" :title="$n(subTotalSecondDepositCount, 'integer')") {{ $n(subTotalSecondDepositCount, 'integer') }}
      tr.footer
        td.text-right(colspan="2")
          span {{ $t("ui.grand_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnover)" :title="$n(grandTotalTurnover, 'currency')") {{ $n(grandTotalTurnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnover)" :title="$n(grandTotalValidTurnover, 'currency')") {{ $n(grandTotalValidTurnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLose)" :title="$n(grandTotalWinLose, 'currency')") {{ $n(grandTotalWinLose, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositAmount)" :title="$n(grandTotalDepositAmount, 'currency')") {{ $n(grandTotalDepositAmount, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositCount)" :title="$n(grandTotalDepositCount, 'integer')") {{ $n(grandTotalDepositCount, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="[grandTotalWithdrawalAmount == 0 ? 'text-primary' : 'text-danger']" :title="$n(grandTotalWithdrawalAmount > 0 ? grandTotalWithdrawalAmount * -1 : grandTotalWithdrawalAmount, 'currency')") {{ $n(grandTotalWithdrawalAmount > 0 ? grandTotalWithdrawalAmount * -1 : grandTotalWithdrawalAmount, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWithdrawalCount)" :title="$n(grandTotalWithdrawalCount, 'integer')") {{ $n(grandTotalWithdrawalCount, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBonusAmount)" :title="$n(grandTotalBonusAmount, 'currency')") {{ $n(grandTotalBonusAmount, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAdjustmentAmount)" :title="$n(grandTotalAdjustmentAmount, 'currency')") {{ $n(grandTotalAdjustmentAmount, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalVerifiedCount)" :title="$n(grandTotalVerifiedCount, 'integer')") {{ $n(grandTotalVerifiedCount, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalActiveMember)" :title="$n(grandTotalActiveMember, 'integer')") {{ $n(grandTotalActiveMember, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalRefereeCount)" :title="$n(grandTotalRefereeCount, 'integer')") {{ $n(grandTotalRefereeCount, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalSignupCount)" :title="$n(grandTotalSignupCount, 'integer')") {{ $n(grandTotalSignupCount, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalFtdCount)" :title="$n(grandTotalFtdCount, 'integer')") {{ $n(grandTotalFtdCount, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalFtdAmount)" :title="$n(grandTotalFtdAmount, 'currency')") {{ $n(grandTotalFtdAmount, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalUniqueLoginCount)" :title="$n(grandTotalUniqueLoginCount, 'integer')") {{ $n(grandTotalUniqueLoginCount, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalUniqueWithdrawalCount)" :title="$n(grandTotalUniqueWithdrawalCount, 'integer')") {{ $n(grandTotalUniqueWithdrawalCount, 'integer') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalSecondDepositCount)" :title="$n(grandTotalSecondDepositCount, 'integer')") {{ $n(grandTotalSecondDepositCount, 'integer') }}
</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    totalTbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    loading: false,
    subTotalTurnover: 0,
    grandTotalTurnover: 0,
    subTotalValidTurnover: 0,
    grandTotalValidTurnover: 0,
    subTotalWinLose: 0,
    grandTotalWinLose: 0,
    subTotalDepositAmount: 0,
    grandTotalDepositAmount: 0,
    subTotalDepositCount: 0,
    grandTotalDepositCount: 0,
    subTotalWithdrawalAmount: 0,
    grandTotalWithdrawalAmount: 0,
    subTotalWithdrawalCount: 0,
    grandTotalWithdrawalCount: 0,
    subTotalBonusAmount: 0,
    grandTotalBonusAmount: 0,
    subTotalAdjustmentAmount: 0,
    grandTotalAdjustmentAmount: 0,
    subTotalActiveMember: 0,
    grandTotalActiveMember: 0,
    subTotalRefereeCount: 0,
    grandTotalRefereeCount: 0,
    subTotalSignupCount: 0,
    grandTotalSignupCount: 0,
    subTotalVerifiedCount: 0,
    grandTotalVerifiedCount: 0,
    subTotalFtdCount: 0,
    grandTotalFtdCount: 0,
    subTotalFtdAmount: 0,
    grandTotalFtdAmount: 0,
    subTotalUniqueLoginCount: 0,
    grandTotalUniqueLoginCount: 0,
    subTotalUniqueWithdrawalCount: 0,
    grandTotalUniqueWithdrawalCount: 0,
    subTotalSecondDepositCount: 0,
    grandTotalSecondDepositCount: 0,
  }),
  watch: {
    tbl(newValue, oldValue) {
      this.getTotal();
    },
  },
  mounted: function() {
    this.getTotal();
  },
  methods: {
    clearTotal() {
      this.subTotalTurnover = 0
      this.grandTotalTurnover = 0
      this.subTotalValidTurnover = 0
      this.grandTotalValidTurnover = 0
      this.subTotalWinLose = 0
      this.grandTotalWinLose = 0
      this.subTotalDepositAmount = 0
      this.grandTotalDepositAmount = 0
      this.subTotalDepositCount = 0
      this.grandTotalDepositCount = 0
      this.subTotalWithdrawalAmount = 0
      this.grandTotalWithdrawalAmount = 0
      this.subTotalWithdrawalCount = 0
      this.grandTotalWithdrawalCount = 0
      this.subTotalBonusAmount = 0
      this.grandTotalBonusAmount = 0
      this.subTotalAdjustmentAmount = 0
      this.grandTotalAdjustmentAmount = 0
      this.subTotalActiveMember = 0
      this.grandTotalActiveMember = 0
      this.subTotalRefereeCount = 0
      this.grandTotalRefereeCount = 0
      this.subTotalSignupCount = 0
      this.grandTotalSignupCount = 0
      this.subTotalVerifiedCount = 0
      this.grandTotalVerifiedCount = 0
      this.subTotalFtdCount = 0
      this.grandTotalFtdCount = 0
      this.subTotalFtdAmount = 0
      this.grandTotalFtdAmount = 0
      this.subTotalUniqueLoginCount = 0,
      this.grandTotalUniqueLoginCount = 0,
      this.subTotalUniqueWithdrawalCount = 0,
      this.grandTotalUniqueWithdrawalCount = 0,
      this.subTotalSecondDepositCount = 0,
      this.grandTotalSecondDepositCount = 0
    },
    getTotal: function() {
      this.clearTotal();
      var tbl = this.tbl;
      if(tbl.length > 0) {
        tbl.forEach(value => {
          this.subTotalTurnover = parseFloat(this.subTotalTurnover) + parseFloat(value["turnover"]);
          this.subTotalValidTurnover = parseFloat(this.subTotalValidTurnover) + parseFloat(value["valid_turnover"]);
          this.subTotalWinLose = parseFloat(this.subTotalWinLose) + parseFloat(value["winlose"]);
          this.subTotalDepositAmount = parseFloat(this.subTotalDepositAmount) + parseFloat(value["deposit_amount"]);
          this.subTotalDepositCount = parseInt(this.subTotalDepositCount) + parseInt(value["deposit_count"]);
          this.subTotalWithdrawalAmount = parseFloat(this.subTotalWithdrawalAmount) + parseFloat(value["withdrawal_amount"]);
          this.subTotalWithdrawalCount = parseInt(this.subTotalWithdrawalCount) + parseInt(value["withdrawal_count"]);
          this.subTotalBonusAmount = parseFloat(this.subTotalBonusAmount) + parseFloat(value["bonus_amount"]);
          this.subTotalAdjustmentAmount = parseFloat(this.subTotalAdjustmentAmount) + parseFloat(value["adjustment_amount"]);
          this.subTotalRefereeCount = parseInt(this.subTotalRefereeCount) + parseInt(value["referee_count"]);
          this.subTotalSignupCount = parseInt(this.subTotalSignupCount) + parseInt(value["signup_count"]);
          this.subTotalVerifiedCount = parseInt(this.subTotalVerifiedCount) + parseInt(value["verified_count"]);
          this.subTotalActiveMember = parseInt(this.subTotalActiveMember) + parseInt(value["active_member"]);
          this.subTotalFtdCount = parseInt(this.subTotalFtdCount) + parseInt(value["ftd_count"]);
          this.subTotalFtdAmount = parseFloat(this.subTotalFtdAmount) + parseFloat(value["ftd_amount"]);
          this.subTotalUniqueLoginCount = parseInt(this.subTotalUniqueLoginCount) + parseInt(value["unique_login_count"]);
          this.subTotalUniqueWithdrawalCount = parseInt(this.subTotalUniqueWithdrawalCount) + parseInt(value["unique_withdrawal_count"]);
          this.subTotalSecondDepositCount = parseInt(this.subTotalSecondDepositCount) + parseInt(value["second_deposit_count"]);
        });

        var totalTbl = this.totalTbl;
        if(totalTbl.length > 0) {
          this.grandTotalTurnover = totalTbl[0]["turnover"];
          this.grandTotalValidTurnover = totalTbl[0]["valid_turnover"];
          this.grandTotalWinLose = totalTbl[0]["winlose"];
          this.grandTotalDepositAmount = totalTbl[0]["deposit_amount"];
          this.grandTotalDepositCount = totalTbl[0]["deposit_count"];
          this.grandTotalWithdrawalAmount = totalTbl[0]["withdrawal_amount"];
          this.grandTotalWithdrawalCount = totalTbl[0]["withdrawal_count"];
          this.grandTotalBonusAmount = totalTbl[0]["bonus_amount"];
          this.grandTotalAdjustmentAmount = totalTbl[0]["adjustment_amount"];
          this.grandTotalActiveMember = totalTbl[0]["active_member"];
          this.grandTotalRefereeCount = totalTbl[0]["referee_count"];
          this.grandTotalSignupCount = totalTbl[0]["signup_count"];
          this.grandTotalVerifiedCount = totalTbl[0]["verified_count"];
          this.grandTotalFtdCount = totalTbl[0]["ftd_count"];
          this.grandTotalFtdAmount = totalTbl[0]["ftd_amount"];
          this.grandTotalUniqueLoginCount = totalTbl[0]["unique_login_count"];
          this.grandTotalUniqueWithdrawalCount = totalTbl[0]["unique_withdrawal_count"];
          this.grandTotalSecondDepositCount = totalTbl[0]["second_deposit_count"];
        }
      }
    }
  }
};
</script>
